module.exports = __webpack_public_path__ + "static/media/publisher.9a0d7f86.svg";